<template>
  <Card dis-hover shadow>
    <div slot="title">
      <Button type="primary" to="login-number">
        <b>返回</b>
      </Button>
    </div>
    <div>
      <h2 class="mb-2">新增登入码</h2>
      <Form
        ref="formCustom"
        :model="formCustom"
        :rules="ruleCustom"
        label-position="top"
        style="max-width: 300px;width: auto;"
      >
        <FormItem label="登入站编号">
          <Select v-model="formCustom.setpgid" size="default">
            <Option v-for="it in select" :key="it.setpgid" :value="it.setpgid">{{it.setpgname}}</Option>
          </Select>
        </FormItem>
        <FormItem label="登入码" prop="incode">
          <Input v-model="formCustom.incode" size="default"></Input>
        </FormItem>
        <FormItem label="导向网址" prop="tourl">
          <Input type="text" v-model="formCustom.tourl" size="default"></Input>
        </FormItem>
        <FormItem label="备注">
          <Input v-model="formCustom.guidetxt" size="default"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formCustom')">新增</Button>
          <Button @click="handleReset('formCustom')" style="margin-left: 8px">重置</Button>
        </FormItem>
      </Form>
    </div>
  </Card>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  name: 'add-login-number',
  data () {
    return {
      select: [],
      formCustom: {
        setpgid: '',
        incode: '',
        tourl: '',
        guidetxt: ''
      },
      ruleCustom: {
        incode: [
          { required: true, message: "请勿留空", trigger: 'blur' },
          { required: true, type: 'string', min: 6, pattern: /^[A-Za-z0-9!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/, message: '最少需6码数字,英文或符号', trigger: 'blur' },
        ],
        tourl: [
          { required: true, message: "请勿留空", trigger: 'blur' },
          { type: 'string', message: "格式错误", trigger: 'blur' },
        ]
      }
    }
  },
  computed: {
    ...mapGetters(['getmember'])
  },
  created () {
    this.getSiteSelect()
  },
  methods: {
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) this.setlineadd()
      })
    },
    handleReset (name) {
      this.$refs[name].resetFields();
    },
    async getSiteSelect () {
      try {
        const res = await this.$axios.websiteManagement.getSiteSelect()
        if ('status' in res && res.status === 0) return
        this.select = res
        this.formCustom.setpgid = res[0].setpgid
      } catch (error) {
        console.error(error);
      }
    },
    async setlineadd () {
      try {
        const obj = {
          ...this.formCustom,
          loid: this.getmember.pid
        }
        const res = await this.$axios.websiteManagement.setlineadd(obj)
        if (res.status == 1) {
          this.$Message.success('新增成功');
          this.$router.push({ name: 'login-number' })
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>